import { styled } from '@/stitches.config';

export const FormStyled = styled('form', {
  margin: 'auto',
});
